import type { Sector } from "../types";

export const sectors: Sector[] = [
  {
    id: "fine-dining-hotels",
    title: "Отели и кейтеринг",
    description:
      "Точные тепловые и холодильные линии, разработанные для кухонь роскошных гостиниц и многофункциональных отелей.",
    image: "/assets/sectors/fine-dining.jpg",
  },
  {
    id: "cafes-bars",
    title: "Кафе и бары",
    description:
      "Компактное, надежное оборудование для быстрого обслуживания напитков и легкого производства.",
    image: "/assets/sectors/cafes-bars.jpg",
  },
  {
    id: "dark-kitchens",
    title: "Фабрики-кухни",
    description:
      "Системы для непрерывного приготовления и хранения, разработанные для кухонь с приоритетом доставки и высокой пропускной способностью.",
    image: "/assets/sectors/dark-kitchens.jpg",
  },
];
